var n=function(n){var t=typeof n;return null!=n&&("object"==t||"function"==t)};export{n as i};
//# sourceMappingURL=isObject.js.map
